<template>
  <modal :show="isModalVisible" @close="isModalVisible = false" class="prompt-modal" :persist="true">
    <div class="modal-header">
      <h3 class="m-0">This is what they will see</h3>
    </div>
    <div class="modal-body d-flex">
      <div v-if="!isEditView">
        <p class="lead" style="max-width: 500px">No sign up needed, just a simple accessible secure link.</p>

        <div class="d-flex flex-column justify-content-end m-0">
          <div class="">
            <small class="text-muted">
              Our verified database ensures your referral is delivered securely to the receiver in a HIPAA compliant
              way.
            </small>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-lg btn-xl btn-primary btn-block m-0" @click="markViewed" :disabled="isSubmitting">
        <font-awesome-icon icon="spinner-third" v-if="isSubmitting" spin />
        <span v-else-if="!isEditView">Ok, great!</span>
        <span v-else>Now it's correct!</span>
      </button>
      <!-- <a href="javascript:;" class="btn btn-link btn-block font-weight-bolder mr-3" @click="isEditView = !isEditView">{{isEditView ? 'Cancel' : 'No, let me update it'}}</a> -->
    </div>
  </modal>
</template>

<script>
import moment from 'moment'
import Modal from '@/components/Modal'
import { mapState, mapGetters } from 'vuex'
import { PracticeApi } from '@/services'
import Autocomplete from '@/components/shared/address-lookup/Autocomplete'
import Cleave from 'vue-cleave-component'
import 'cleave.js/dist/addons/cleave-phone.us'
export default {
  components: { Modal, Autocomplete, Cleave },
  data() {
    return {
      isModalVisible: true,
      isSubmitting: false,
      isEditView: false,
      practice: { ...this.$store.state.auth.user.practice },
      cleave: {
        phone: { phone: true, phoneRegionCode: 'us' },
      },
    }
  },
  computed: {
    ...mapState('auth', ['user', 'token', 'error']),
    ...mapGetters('referrals', ['get']),
    referral() {
      return this.get(this.$route.query.e)
    },
  },
  mounted() {},
  methods: {
    async confirmPractice() {
      this.isSubmitting = true
      try {
        await this.$store.dispatch('practices/save', this.practice)
        await PracticeApi.saveRelated(this.practice.id, 'complete-setup', {}, { json: false })
        this.isModalVisible = false
        await this.$store.dispatch('practices/refreshCurrentUserPractice')
        await this.$store.dispatch('referrals/load', true)
      } catch (err) {
        this.$exception(err)
      }
      this.isSubmitting = false
    },
    markViewed() {
      this.isSubmitting = true
      try {
        if (!this.referral?.receiver_viewed_at_time) {
          //todo: endpoint for this which checks user ss
          this.$store.dispatch('referrals/save', {
            ...this.referral,
            receiver_viewed_at_time: moment().utc().toISOString(),
          })
        }
      } catch (er) {
        console.error(er)
      }
      this.isModalVisible = false
      this.isSubmitting = false
    },
    addressSelected: function (address) {
      this.practice.address = address.address
      this.practice.address_2 = address.address_2
      this.practice.city = address.city
      this.practice.state = address.state
      this.practice.zip = address.zip
      this.practice.location = address.location
    },
  },
}
</script>
<style scoped lang="scss">
.prompt-modal .modal-container {
  width: 100%;
}
@media (min-width: 576px) {
  .prompt-modal .modal-container {
    width: 550px;
  }
}
</style>
